import moment from 'moment';
import Photo from '../../../../sharedComponents/photo/Photo.vue';

export default {
  name: 'LegalDocInfoPanel',
  components: { Photo },
  props: ['form', 'isEditable'],
  mounted() {
    this.loadCompanies(this.form.customer_inn);
  },
  watch: {
    searchCompany(val) {
      this.loadCompanies(val);
    },
  },
  computed: {
    // Процесс выполнения запроса к серверу
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    loadCompanies(val) {
      this.$store.getters.axl
        .post('/sales/api/companies/find-by-inn', { inn: val })
        .then((result) => {
          this.companies = result.data.data;
        });
    },
  },
  data() {
    return {
      // Максимальное значение даты
      maxDate: moment().format('YYYY-MM-DD'),
      // v-model для компонента выбора даты ТТН или УПД
      ttn_date_menu: false,
      // Компании
      companies: [],
      // Поиск компании по ИНН
      searchCompany: '',
      // Правила валидации формы
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
    };
  },
};
